// Mirrors Ember cp-validations format validator (minTldLength: 2)
export const EMAIL_REGEX =
	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

/**
 * Validates a location ref used as a URL path segment and localStorage key.
 * Allows only alphanumerics, hyphens, and underscores — blocks path traversal and injection chars.
 */
export function isValidRef(value: unknown): value is string {
	return typeof value === 'string' && /^[a-zA-Z0-9_-]{1,64}$/.test(value)
}

export function formatPhoneNumber(phone: string): string {
	if (!phone) return ''
	const digits = phone.replace(/\D/g, '')
	if (digits.length === 10) {
		return digits.replace(/(\d{3})(\d{3})(\d{4})/, '+1 $1-$2-$3')
	}
	if (digits.length === 11 && digits.startsWith('1')) {
		return digits.replace(/(\d)(\d{3})(\d{3})(\d{4})/, '+$1 $2-$3-$4')
	}
	return phone
}
